var React = require('react');

function Cloud1 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M18.2633 34.6097C18.2633 34.6097 18.0126 26.5148 26.0646 22.9736C34.1166 19.4323 41.6635 25.4399 41.6635 25.4399C41.6635 25.4399 36.8585 12.3459 46.7808 4.94684C56.7031 -2.45225 71.9896 -2.76885 79.7909 12.4749C79.7909 12.4749 88.4638 -3.58967 107.56 8.67961C107.56 8.67961 121.165 18.5451 112.242 36.5093C112.242 36.5093 120.228 35.622 122.912 41.3169C125.596 47.0079 123.599 57.0024 114.05 57.0024H12.1472C12.1472 57.0024 0.913711 57.0649 0.0421823 45.0497C-0.829346 33.0345 12.0238 30.4978 18.2633 34.6097Z","fill":"#EDF1F3"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"124","height":"57","fill":"white"})))]);
}

Cloud1.defaultProps = {"width":"124","height":"57","viewBox":"0 0 124 57","fill":"none"};

module.exports = Cloud1;

Cloud1.default = Cloud1;
